<template lang="pug">
div
  .md-headline Allowed platforms
  md-layout
    md-layout(md-flex='50')
      md-switch.md-primary(v-model='entity.platforms.desktop')
        .switch-label
          md-icon(md-iconset="fa fa-desktop")
          span Desktop
    md-layout(md-flex='50')
      md-switch.md-primary(v-model='entity.platforms.tablet')
        .switch-label
          md-icon(md-iconset="fa fa-tablet-alt")
          span Tablet
  md-layout
    md-layout(md-flex='50')
      md-switch.md-primary(v-model='entity.platforms.mobile_web')
        .switch-label
          md-icon(md-iconset="fa fa-mobile-alt").rotated
          span Mobile Web
    md-layout(md-flex='50')
      md-switch.md-primary(v-model='entity.platforms.mobile_app')
        .switch-label
          md-icon(md-iconset="fa fa-mobile-alt")
          span Mobile App
  md-layout
    md-layout(md-flex='50')
      md-switch.md-primary(v-model='entity.platforms.connectedtv')
        .switch-label
          md-icon(md-iconset="fa fa-tv")
          span ConnectedTV

  md-layout.platforms-info(md-flex='100', md-align='center')
    div(v-show='showPlatformsInfo') Player only available on selected platforms

</template>

<script>
  export default {
    props: {
      entity: {
        type: Object,
        required: true
      }
    },
    computed: {
      showPlatformsInfo() {
        return !(this.entity.platforms.desktop
              && this.entity.platforms.tablet
              && this.entity.platforms.mobile_web
              && this.entity.platforms.mobile_app
              && this.entity.platforms.connectedtv);
      }
    }
  };
</script>

<style lang="scss">

  .md-headline {
    margin-bottom: 15px;
  }
  .platforms-info {
    height: 18px;
    color: #9e9e9e;
  }
  .switch-label {
    margin-top: -4px;
    .md-icon {
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/PlatformsForm.vue